import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useProductListStore = defineStore('useProductListStore', () => {
  const products = ref<any[]>([]);
  const loadingQuantityInputs = ref<Record<string, any>>({});
  const maxHeadings = ref(0);
  const shopType = ref('default');
  const approvalsEnabled = ref(false);

  const setProducts = (value: any[]) => {
    products.value = value;
  };

  const setLoadingQuantityInputs = (value: Record<string, any>) => {
    loadingQuantityInputs.value = value;
  };

  const setMaxHeadings = (value: number) => {
    maxHeadings.value = value;
  };

  const setShopType = (value: string) => {
    shopType.value = value;
  };

  const setApprovalsEnabled = (value: boolean) => {
    approvalsEnabled.value = value;
    localStorage.setItem('productList:approvalsEnabled', String(value));
  };

  return {
    products,
    loadingQuantityInputs,
    maxHeadings,
    shopType,
    approvalsEnabled,
    setProducts,
    setLoadingQuantityInputs,
    setMaxHeadings,
    setShopType,
    setApprovalsEnabled,
  };
});
